import { flattenEntityTree } from './brainEntityTree';
import type { BrainEntityView } from '../../../../../../../../models/companyBrain';

export enum BrainAskSuggestionKind {
  DECIDED = 'decided',
  OWNER = 'owner',
  BLOCKED = 'blocked',
}

export interface BrainAskSuggestion {
  kind: BrainAskSuggestionKind;
  entityName?: string;
}

export function pickTopEntity(
  roots: readonly BrainEntityView[],
): BrainEntityView | null {
  let top: BrainEntityView | null = null;
  for (const entity of flattenEntityTree(roots)) {
    if (
      entity.activeAssertionCount > 0 &&
      entity.activeAssertionCount > (top?.activeAssertionCount ?? 0)
    ) {
      top = entity;
    }
  }
  return top;
}

export function buildBrainAskSuggestions(
  roots: readonly BrainEntityView[],
): BrainAskSuggestion[] {
  const top = pickTopEntity(roots);
  const blocked: BrainAskSuggestion = { kind: BrainAskSuggestionKind.BLOCKED };
  if (top === null) {
    return [blocked];
  }
  return [
    { kind: BrainAskSuggestionKind.DECIDED, entityName: top.canonicalName },
    { kind: BrainAskSuggestionKind.OWNER, entityName: top.canonicalName },
    blocked,
  ];
}
